var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarfruit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#FECB1C;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.48,54.9c0,0-4.03,7.95-5.74,10.6c-1.71,2.65-6.63,7.18-8.28,12.7c-1.66,5.52-1.77,8.51-1.77,8.51 s-8.56-1.05-14.64,2.71c-6.08,3.76-17.67,6.3-17.67,6.3s5.08,4.25,6.63,6.52c1.55,2.26,6.52,7.9,10.38,10.6 c3.87,2.71,6.52,4.09,6.52,4.09s-4.47,6.9-3.98,13.81c0.5,6.9-0.5,10.66,0.44,14.47s1.77,5.74,1.77,5.74s13.15-7.01,16.13-8.28 c2.98-1.27,6.19-2.76,8.4-5.63c2.21-2.87,2.76-3.53,2.76-3.53s3.04,4.86,8.28,5.85c5.25,0.99,7.95,3.37,11.49,4.09 s9.89,2.98,10.16,2.98s-1.05-5.85-0.77-9.39s-0.61-11.38-2.32-15.58c-1.71-4.2-3.65-7.51-3.65-7.51s4.81-0.88,9.33-5.47 c4.53-4.58,9.61-8.89,12.48-9.61c2.87-0.72,3.65-1.1,3.65-1.1s-14.14-9.11-20.33-10.71c-6.19-1.6-13.48-0.66-13.48-0.66 s-1.6-8.62-6.3-16.24C111.28,62.53,106.48,54.9,106.48,54.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.94,105.11c-1.64-1.7-3.88-2.71-6.07-3.5c-2.44-0.89-4.96-1.63-7.58-1.52 c-6.68,0.28-20.33-2.43-20.33-2.43s11.6,3.42,13.81,4.97s3.98,3.42,10.6,4.2c2.2,0.26,4.41,0.44,6.62,0.4 c1.12-0.02,2.25-0.1,3.36-0.26c0.72-0.11,0.82-0.14,0.42-0.78C104.54,105.79,104.25,105.43,103.94,105.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.88,105.11c1.64-1.7,3.88-2.71,6.07-3.5c2.44-0.89,4.96-1.63,7.58-1.52c6.68,0.28,20.33-2.43,20.33-2.43 s-11.6,3.42-13.81,4.97c-2.21,1.55-3.98,3.42-10.6,4.2c-2.2,0.26-4.41,0.44-6.62,0.4c-1.12-0.02-2.25-0.1-3.36-0.26 c-0.72-0.11-0.82-0.14-0.42-0.78C108.28,105.79,108.56,105.43,108.88,105.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.67,108.55c-2.15,0.97-3.85,2.75-5.33,4.54c-1.65,2-3.19,4.13-3.97,6.63c-1.98,6.39-9.1,18.34-9.1,18.34 s7.11-9.78,9.31-11.35c2.2-1.56,4.56-2.6,7.51-8.59c0.98-1.98,1.89-4.01,2.6-6.1c0.36-1.07,0.66-2.15,0.88-3.26 c0.14-0.71,0.14-0.82-0.6-0.65C104.52,108.21,104.08,108.36,103.67,108.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.28,108.39c2.22,0.79,4.07,2.41,5.7,4.07c1.81,1.85,3.53,3.84,4.51,6.27c2.51,6.2,10.61,17.5,10.61,17.5 s-7.91-9.15-10.23-10.52c-2.32-1.37-4.76-2.21-8.2-7.92c-1.14-1.89-2.22-3.83-3.1-5.86c-0.45-1.03-0.84-2.09-1.15-3.17 c-0.2-0.7-0.21-0.8,0.54-0.7C108.41,108.13,108.86,108.24,109.28,108.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.31,104.77c-1.22-2.02-1.63-4.45-1.83-6.76c-0.23-2.58-0.3-5.21,0.47-7.71 c1.98-6.39,2.86-20.27,2.86-20.27s0.34,12.09,1.27,14.62s2.29,4.72,1.34,11.33c-0.31,2.19-0.7,4.37-1.31,6.5 c-0.31,1.08-0.67,2.15-1.11,3.18c-0.29,0.66-0.35,0.76-0.86,0.2C105.82,105.53,105.55,105.16,105.31,104.77z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfruit);
export default __webpack_public_path__ + "static/media/Starfruit.d7902eec99ca785d3bfb7d68f22571dc.svg";
export { ForwardRef as ReactComponent };